import { FunctionComponent } from "react";
import { arrowBack } from "ionicons/icons";
import { IonBackButton } from "@ionic/react";

export const EditIonBackButton: FunctionComponent<{ defaultHref: string }> = ({ defaultHref }) => (
  <IonBackButton text={""} icon={arrowBack} defaultHref={defaultHref} />
);
